export const KEY_PRESS_DEBOUNCE_TIME = 875;
export const TEST_SUBMISSION_EMAIL = 'eontwikkeling@essent.nl';
